import React from "react";
import { TableCell } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import type { IMarketTradeHourTableReport } from "src/Interfaces/marketTradeHour";

interface IProps extends IAdditionalHeaderProps {}

const AdditionalHeader: React.FC<IProps> = () => {
  return <TableCell><b>ویرایش</b></TableCell>;
};

const buildAdditionalRow = (
  onEdit: (marketTradeHoursTypeId: number) => void,
): React.FC<{
  row: IMarketTradeHourTableReport;
  onAction: () => void;
  selectedRowsIds: number[];
  setSelectedRowsIds: (selectedRowsIds: number[]) => void;
}> => {
  const AdditionalRow: React.FC<{
    row: IMarketTradeHourTableReport;
    onAction: () => void;
    selectedRowsIds: number[];
    setSelectedRowsIds: (selectedRowsIds: number[]) => void;
  }> = ({ row }) => {
    return (
      <TableCell>
        <div className="w-16 mx-auto flex items-center justify-center">
          <EditIcon
            className="text-sky-700 cursor-pointer"
            onClick={() => onEdit(row.marketTradeHoursTypeId)}
          />
        </div>
      </TableCell>
    );
  };

  return AdditionalRow;
};

export const createAdditional = (
  onEdit: (marketTradeHoursTypeId: number) => void,
): IAdditional<IMarketTradeHourTableReport> => ({
  getHeader: AdditionalHeader,
  getRow: buildAdditionalRow(onEdit),
});
